import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import * as constants from '../_model/string_literal';
@Injectable({
  providedIn: 'root'
})
export class AttachmentService {
  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    const parsedToken = token ? JSON.parse(token) : null;
    return new HttpHeaders({
      'Authorization': parsedToken?.token ? `Bearer ${parsedToken.token}` : ''
    });
  }

  get httpOptionsAuth() {
    return { headers: this.getAuthHeaders() };
  }

  constructor(
    private http: HttpClient,
  ) { }

  uploadFile(file: any) {
    return this.http.post(constants.IAPI_ENDPOINT + '/attachment', file, this.httpOptionsAuth);
  }

  updateFile(data: any) {
    const httpOptions = {
      ...this.httpOptionsAuth,
      headers: this.httpOptionsAuth.headers.set('Content-Type', 'application/json'),
    };
    return this.http.put(constants.IAPI_ENDPOINT + '/attachment', JSON.stringify(data), httpOptions);
  }

  getAttachment(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + `/attachment/${id}`, this.httpOptionsAuth);
  }

  getAttachmentContents(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + `/attachment/${id}/contents`, {
      ...this.httpOptionsAuth,
      responseType: 'blob',
    });
  }

  getAttachmentThumb(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + `/attachment/${id}/thumbnail`, {
      ...this.httpOptionsAuth,
      responseType: 'blob',
    });
  }
}
